import { render, staticRenderFns } from "./AddWareHouseButton.vue?vue&type=template&id=2d21b5ac&"
import script from "./AddWareHouseButton.vue?vue&type=script&lang=js&"
export * from "./AddWareHouseButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports